import PropTypes from "prop-types";
import React from "react";

const CX = 100;
const CY = 100;
const R = 84;
const ARC = `M ${CX - R} ${CY} A ${R} ${R} 0 0 1 ${CX + R} ${CY}`;

const pointOnArc = (fraction, radius) => {
  const angle = Math.PI * (1 - fraction);
  return [CX + radius * Math.cos(angle), CY - radius * Math.sin(angle)];
};

const clamp = (value) => Math.min(Math.max(value, 0), 1);

const TicketSalesGauge = ({ sold, capacity, percentage, forecast }) => {
  const filled = clamp(percentage / 100) * 100;
  const forecastFraction = capacity > 0 && forecast > 0 ? clamp(forecast / capacity) : null;
  const tick = forecastFraction == null ? null : [pointOnArc(forecastFraction, R - 11), pointOnArc(forecastFraction, R + 13)];

  return (
    <div
      className="ticket-sales-gauge"
      role="img"
      aria-label={`${sold} of ${capacity} sold, ${percentage}%${forecastFraction == null ? "" : `. Forecast ${forecast}`}`}
    >
      <svg viewBox="0 0 200 112" aria-hidden="true">
        <path d={ARC} pathLength="100" className="ticket-sales-gauge__trail" />
        {filled > 0 ? (
          <path d={ARC} pathLength="100" strokeDasharray={`${filled} 100`} className="ticket-sales-gauge__fill" />
        ) : null}
        {tick ? (
          <line x1={tick[0][0]} y1={tick[0][1]} x2={tick[1][0]} y2={tick[1][1]} className="ticket-sales-gauge__forecast" />
        ) : null}
      </svg>
      <div className="ticket-sales-gauge__readout">
        <div className="ticket-sales-gauge__sold">{sold}</div>
        <div className="ticket-sales-gauge__caption">
          of {capacity} sold · <span className="ticket-sales-gauge__percent">{percentage}%</span>
        </div>
      </div>
    </div>
  );
};

TicketSalesGauge.propTypes = {
  sold: PropTypes.number.isRequired,
  capacity: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  forecast: PropTypes.number,
};

TicketSalesGauge.defaultProps = { forecast: null };

export default TicketSalesGauge;
